const HowItWorksSteps = () => {
  const bigSlides = [...document.querySelectorAll(".how-it-works__slider-big .swiper-slide")];

  if (bigSlides.length > 0) {
    bigSlides.forEach((bigSlide) => {
      const steps = [...bigSlide.querySelectorAll(".how-it-works__slide-steps-item")];
      const animations = [...bigSlide.querySelectorAll(".how-it-works__slide-step-animation")];

      if (animations.length > 0 && animations.length > 0) {
        steps[0].classList.add("active");
        animations[0].classList.add("active");

        steps.forEach((step, index) => {
          step.addEventListener("click", () => {
            steps.forEach((s) => s.classList.remove("active"));
            animations.forEach((a) => a.classList.remove("active"));

            step.classList.add("active");
            animations[index].classList.add("active");
          })
        })
      }
    })
  }
}

export default HowItWorksSteps;